document.addEventListener("DOMContentLoaded", () => {

    function initMenuDropdowns(){

        // top level items
        let items = document.querySelectorAll('#main-navigation .menu > .menu-item-has-children > a');
    
        if(items){
            items.forEach( item => item.addEventListener( 'click', e => { e.preventDefault();
                
                if (!document.startViewTransition) {
                    handleMenuClick(e);
                    return;
                }
    
                // startViewTransition is what does the fading effect
                document.startViewTransition( () => handleMenuClick(e) );
    
            }));
        }

        // Search button
        let search = document.getElementById('search-trigger');

        if(search){
            search.addEventListener( 'click', closeOpenMenuDropdown );
        }

    }

    function handleMenuClick(e){
        
        e.preventDefault();

        maybeCloseSearch();
        
        let parentItem = e.target.closest('.menu-item-has-children');

        if( parentItem.classList.contains('open') ){
            closeMenuDropdown(parentItem);
        }else{
            closeOpenMenuDropdown();
            openMenuDropdown(parentItem);
        }

    }

    function openMenuDropdown(element){
        element.classList.add('open');
        window.addEventListener( 'keydown', handleMenuKeypress );
    }
    
    function closeMenuDropdown(element){
        element.classList.remove('open');
        window.removeEventListener( 'keydown', handleMenuKeypress );
    }
    
    function closeOpenMenuDropdown(){
        let currentOpen = document.querySelector('#main-navigation .menu > .menu-item-has-children.open');
        if(currentOpen){
            closeMenuDropdown(currentOpen);
        }
    }

    function handleMenuKeypress(e){
        if( e.key != "Escape" ) return;
        
        if (!document.startViewTransition) {
            return closeOpenMenuDropdown();
        }
        
        document.startViewTransition( () => closeOpenMenuDropdown() );
    }

    function maybeCloseSearch(){
        let openSearch = document.querySelector('#search-trigger.is-open');
        let seachContainer = document.getElementById('searchform');
        if(openSearch){
            openSearch.classList.remove('is-open');
            seachContainer.style.display = "none";
        }
    }

    initMenuDropdowns();

} );